import {
  Env,
  User,
  BarStyle,
  ShareData,
  CandyBoxShare,
  LogEvent
} from "@/types";

export default class FoxBridge {
  static property = "bridge";

  private enabled: boolean;

  private handlerIdx = 0;

  private perfixes = {
    success: "jsb-success-callback-",
    error: "jsb-error-callback-"
  };

  private successHandlersMap = {};

  private handlers: { [x: string]: Function } = {};

  constructor() {
    const jsb = (window as any).FoxJSBridge;
    this.enabled = Boolean(jsb && jsb.postMessage);
    if (this.enabled) {
      jsb.receiveMessage = this.$onMessage;
    }
  }

  public post = (
    method: string,
    data: any,
    success: Function,
    failure: Function
  ) => {
    const { successCbId, failureCbId } = this.$addHandler(success, failure);
    const jsb = (window as any).FoxJSBridge;
    if (jsb && jsb.postMessage) {
      jsb.postMessage(
        JSON.stringify({
          method,
          data,
          successCallbackId: successCbId,
          failureCallbackId: failureCbId
        })
      );
      setTimeout(() => {
        if (!this.handlers[successCbId]) {
          return;
        }
        failure({ code: "-2", message: "timeout" });
      }, 5000);
    } else {
      failure({ message: "bridge not exist" });
    }
  };

  getEnv(): Promise<Env> {
    return new Promise((resolve, reject) => {
      this.post("getEnv", null, resolve, reject);
    });
  }

  getUser(): Promise<User> {
    return new Promise((resolve, reject) => {
      this.post("getUser", null, resolve, reject);
    });
  }

  getToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.post("getToken", null, resolve, reject);
    });
  }

  dismiss() {
    return new Promise((resolve, reject) => {
      this.post("dismiss", null, resolve, reject);
    });
  }

  hideNavigationBar() {
    return new Promise((resolve, reject) => {
      this.post("hideNavigationBar", null, resolve, reject);
    });
  }

  showNavigationBar() {
    return new Promise((resolve, reject) => {
      this.post("showNavigationBar", null, resolve, reject);
    });
  }

  /** 设置导航栏颜色 */
  setNavigationBarStyle(data: BarStyle) {
    return new Promise((resolve, reject) => {
      this.post("setNavigationBarStyle", data, resolve, reject);
    });
  }

  /** 设置状态栏颜色 */
  setStatusBarStyle(data: BarStyle) {
    return new Promise((resolve, reject) => {
      this.post("setStatusBarStyle", data, resolve, reject);
    });
  }

  share(data: ShareData) {
    return new Promise((resolve, reject) => {
      this.post("share", data, resolve, reject);
    });
  }

  shareCandyBox(data: CandyBoxShare) {
    return new Promise((resolve, reject) => {
      this.post("shareCandyBox", data, resolve, reject);
    });
  }

  updateMembership() {
    return new Promise((resolve, reject) => {
      this.post("updateMembership", null, resolve, reject);
    });
  }

  logEvent(data: LogEvent) {
    return new Promise((resolve, reject) => {
      this.post("logEvent", data, resolve, reject);
    });
  }

  private $addHandler = (success: Function, failure: Function) => {
    const successCbId = this.perfixes.success + this.handlerIdx++;
    const failureCbId = this.perfixes.error + this.handlerIdx++;
    this.successHandlersMap = {
      ...this.successHandlersMap,
      [successCbId]: failureCbId
    };
    this.handlers[successCbId] = success;
    this.handlers[failureCbId] = failure;
    return { successCbId, failureCbId };
  };

  private $onMessage = (msg: string) => {
    const { data, callbackId } = JSON.parse(msg);
    const { [callbackId]: callback } = this.handlers;
    if (callback) {
      callback(data);
    }
    delete this.handlers[callbackId];
    if (callbackId.includes(this.perfixes.success)) {
      delete this.handlers[this.successHandlersMap[callbackId]];
    }
  };
}
